import { MutationTree } from 'vuex';
import { TrainerHoursState } from './types';
import trainerHours from '@/shared/model/trainerHours';
import { Value } from '@/shared/model/trainerHours';

export const mutations: MutationTree<TrainerHoursState> = {
  setTrainerHours(state, payload: Value) {
    state.trainerHours.items = payload.value.map((x) => trainerHours.parse(x));
    state.trainerHours.total = payload['@odata.count'] || 0;
    state.trainerHours.isLoading = false;
  },
  setTrainerHoursTotal(state, payload: number) {
    state.trainerHours.total = payload;
  },
  setTrainerHoursIsLoading(state, payload: boolean) {
    state.trainerHours.isLoading = payload;
  },
  resetTrainerHoursPaging(state) {
    state.trainerHours.searchParams.dataOption.page = 1;
    state.trainerHours.searchParams.dataOption.itemsPerPage = 10;
    state.trainerHours.searchParams.dataOption.filter = '';
    state.trainerHours.searchParams.filter = '';
  },
};
